import AssignmentSubSection from './AssignmentSubSection';

export default AssignmentSubSection;
